import './verticalBar.css';

export default function VerticalBar({height, offsetX, offsetY, color, center}) {
    return(
        <div className="vertical-bar"
            style={{
                width: '0.3rem',
                height: height,
                background: color,
                transform: `translateX(${offsetX})`,
                transform: `translateY(${offsetY})`,
                margin: center 
            }}
        />
    )
}